module.exports = __webpack_public_path__ + "img/0.cc056899.jpg";